
<template>

<el-tabs v-model="activeName" type="card" >

    <el-tab-pane label="二手车" name="first">
        <goods-list ref="clue-management" :businessId="businessId" type="二手车"></goods-list>
    </el-tab-pane>

    <el-tab-pane label="新车" name="two">
        <goods-list ref="clue-management" :businessId="businessId" type="新车"></goods-list>
    </el-tab-pane>

    <el-tab-pane label="机油保养" name="four" >
        <goods-list ref="clue-management" :businessId="businessId" type="机油保养"></goods-list>
    </el-tab-pane>
    <el-tab-pane label="洗车打蜡" name="five" >
        <goods-list ref="clue-management" :businessId="businessId" type="洗车打蜡"></goods-list>
    </el-tab-pane>
    <el-tab-pane label="汽车用品" name="six" >
        <goods-list ref="clue-management" :businessId="businessId" type="汽车用品"></goods-list>
    </el-tab-pane>
    <el-tab-pane label="改装装潢" name="seven" >
        <goods-list ref="clue-management" :businessId="businessId" type="改装装潢"></goods-list>
    </el-tab-pane>
    <el-tab-pane label="汽车维修" name="eight" >
        <goods-list ref="clue-management" :businessId="businessId" type="汽车维修"></goods-list>
    </el-tab-pane>

    <el-tab-pane label="车驾管服务" name="nine" >
        <goods-list ref="clue-management" :businessId="businessId" type="车驾管服务"></goods-list>
    </el-tab-pane>

    <el-tab-pane label="保险服务" name="ten" >
        <goods-list ref="clue-management" :businessId="businessId" type="保险服务"></goods-list>
    </el-tab-pane>

    <el-tab-pane label="驾培服务" name="eleven" >
        <goods-list ref="clue-management" :businessId="businessId" type="驾培服务"></goods-list>
    </el-tab-pane>

    <el-tab-pane label="其他服务" name="twelve" >
        <goods-list ref="clue-management" :businessId="businessId" type="其他服务"></goods-list>
    </el-tab-pane>
</el-tabs>

</template>

<script>
import GoodsList from './children/GoodsList'
export default {
  name: 'plusGoods-tab-index1',
  data () {
    return {
      businessId: null,
      isAdmin: false,
      activeName: 'first'
    }
  },
  created: function () {
    let params = this.$route.params

    this.businessId = params.businessId
  },
  activated: function () {
    let params = this.$route.params

    this.businessId = params.businessId
  },
  mounted: function () {
  },
  components: {
    GoodsList
  },
  methods: {}
}

</script>
